import { useId } from 'react'

export function DsSplashIllustration({ size = 220, semanticLabel, className }: { size?: number; semanticLabel: string; className?: string }) {
  const id = useId()
  const p = 'var(--brand-vivid)'
  const teal = '#14B8A6'
  return (
    <svg role="img" aria-label={semanticLabel} width={size} height={size} viewBox="0 0 240 240" className={className}>
      <defs>
        <radialGradient id={`${id}-glow`}>
          <stop offset="0" stopColor={p} stopOpacity="0.2" />
          <stop offset="0.4" stopColor={teal} stopOpacity="0.12" />
          <stop offset="0.7" stopColor={teal} stopOpacity="0" />
        </radialGradient>
        <linearGradient id={`${id}-left`} x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="var(--card)" /><stop offset="1" stopColor="var(--border)" /></linearGradient>
        <linearGradient id={`${id}-right`} x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="var(--muted)" /><stop offset="1" stopColor="var(--border)" /></linearGradient>
        <linearGradient id={`${id}-roof`} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor={p} stopOpacity="0.9" /><stop offset="1" stopColor={teal} stopOpacity="0.8" /></linearGradient>
        <linearGradient id={`${id}-gold`} x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#FDE047" /><stop offset="1" stopColor="#EAB308" /></linearGradient>
      </defs>
      <circle cx="120" cy="120" r="130" fill={`url(#${id}-glow)`} />
      <path d="M120 210 L40 165 L120 120 L200 165 Z" fill="none" stroke="var(--muted-foreground)" strokeOpacity="0.35" strokeWidth="1" />
      <g style={{ animation: 'ds-bob 5s ease-in-out infinite' }}>
        <path d="M80 145 L120 165 L120 95 L80 75 Z" fill={`url(#${id}-left)`} stroke="var(--border)" />
        <path d="M120 165 L160 145 L160 75 L120 95 Z" fill={`url(#${id}-right)`} stroke="var(--muted-foreground)" strokeOpacity="0.6" />
        <path d="M120 95 L160 75 L120 55 L80 75 Z" fill={`url(#${id}-roof)`} stroke={p} strokeWidth="1.5" />
        {[85, 105, 125].map((y) => (
          <g key={y}>
            <path d={`M90 ${y} L110 ${y + 10} L110 ${y + 6} L90 ${y - 4} Z`} fill={p} fillOpacity="0.24" />
            <path d={`M130 ${y + 10} L150 ${y} L150 ${y - 4} L130 ${y + 6} Z`} fill="var(--muted-foreground)" fillOpacity="0.35" />
          </g>
        ))}
        <path d="M110 160 L120 165 L120 150 L110 145 Z" fill={p} fillOpacity="0.8" />
      </g>
      <g style={{ transformOrigin: '64px 99px', animation: 'ds-bob 5s ease-in-out infinite', animationDelay: '-2s' }}>
        <rect x="42" y="70" width="44" height="58" rx="5" fill="var(--card)" stroke={p} strokeWidth="1.5" />
        <rect x="48" y="78" width="20" height="3" rx="1.5" fill={p} />
        <rect x="47" y="86" width="28" height="2" rx="1" fill="var(--border)" />
        <rect x="46" y="92" width="24" height="2" rx="1" fill="var(--border)" />
        <rect x="45" y="98" width="28" height="2" rx="1" fill="var(--border)" />
        <circle cx="66" cy="114" r="5" fill={p} fillOpacity="0.2" stroke={p} />
        <path d="M64 114 L65.5 115.5 L68.5 112.5" fill="none" stroke={p} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <g style={{ transformOrigin: '178px 76px', animation: 'ds-sway 5s ease-in-out infinite' }}>
        <circle cx="178" cy="76" r="11" fill={`url(#${id}-gold)`} />
        <circle cx="178" cy="76" r="5" fill="var(--background)" />
        <rect x="176" y="87" width="4" height="24" fill="#EAB308" />
        <rect x="180" y="99" width="6" height="3" fill="#EAB308" />
        <rect x="180" y="105" width="4.5" height="3" fill="#EAB308" />
        <path d="M196 70 L197.5 73 L200.5 74 L197.5 75 L196 78 L194.5 75 L191.5 74 L194.5 73 Z" fill="#FACC15" style={{ transformOrigin: '196px 74px', animation: 'ds-pulse-scale 2s ease-in-out infinite' }} />
      </g>
      <g style={{ animation: 'ds-bob 4s ease-in-out infinite', animationDelay: '-1s' }}>
        <rect x="110" y="178" width="82" height="22" rx="11" fill="var(--card)" stroke={p} strokeWidth="1.2" />
        <circle cx="121" cy="189" r="4.5" fill={p} />
        <path d="M119 189 L120.5 190.5 L123.5 187.5" fill="none" stroke="#fff" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <text x="130" y="192" fontSize="8" fontWeight="700" letterSpacing="0.4" fill="var(--foreground)" fontFamily="var(--font-sans)">ACTIVE LEASE</text>
      </g>
    </svg>
  )
}
